import React, { useState, useEffect } from "react";

export default function TerminalFeed() {
 const messages = [
  ">> BTUI_25 sequence initialized…",
  "[SYS] Creativity core compiling",
  "[AUTH] terminal link verified..",
  "[NODE] Sri Lanka ICT grid connected…..",
  "--- WARNING: Innovation overload detected ---",
  "[SYNC] Beyond the interface protocols engaged",
  ">> User experience pipeline unlocked",
  ">>> Transmission uplink... ACTIVE",
  "[AI] Generating immersive content layers",
  ":: FUTURE TIMELINE REWRITTEN ::",
  "[DATA] Next-gen coders authenticated…",
  "[SYS] Knowledge modules streaming",
  ">> Vision engines aligned",
  "[NET] Global channel open",
  ":: glitch// 01X4C RECONFIGURED ::",
  "[SECURE] Encryption key accepted",
  "-- EXPERIENCE CORE STABILIZED",
  ">>> LIVE STATUS: BTUI_25"
];

  const [lines, setLines] = useState([]);
  const [currentLine, setCurrentLine] = useState("");
  const [msgIndex, setMsgIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const typingSpeed = 40;
    const interval = setInterval(() => {
      const msg = messages[msgIndex];
      if (charIndex < msg.length) {
        setCurrentLine((prev) => prev + msg[charIndex]);
        setCharIndex((prev) => prev + 1);
      } else {
        setLines((prev) => {
          const next = [...prev, msg];
          if (next.length > 8) next.shift();
          return next;
        });
        setCurrentLine("");
        setCharIndex(0);
        setMsgIndex((prev) => (prev + 1) % messages.length);
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [charIndex, msgIndex]);

  return (
    <div className="terminal-feed">
      {lines.map((line, idx) => (
        <div key={idx}>{line}</div>
      ))}
      {currentLine && <div>{currentLine}</div>}
    </div>
  );
}
